module.exports = __webpack_public_path__ + "static/media/mixed-reality.08810b54.jpg";